import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import loginJa from "./locales/ja/login.json";
import loginEn from "./locales/en/login.json";
import dashboardJa from "./locales/ja/dashboard.json";
import dashboardEn from "./locales/en/dashboard.json";
import settingJa from "./locales/ja/setting.json";
import settingEn from "./locales/en/setting.json";
import boardJa from "./locales/ja/board.json";
import boardEn from "./locales/en/board.json";
import taskJa from "./locales/ja/task.json";
import taskEn from "./locales/en/task.json";
import analyticsJa from "./locales/ja/analytics.json";
import analyticsEn from "./locales/en/analytics.json";
import settlementJa from "./locales/ja/settlement.json";
import settlementEn from "./locales/en/settlement.json";
import driverShiftJa from "./locales/ja/driverShift.json";
import driverShiftEn from "./locales/en/driverShift.json";
import guestJa from "./locales/ja/guest.json";
import guestEn from "./locales/en/guest.json";
import callHistoryJa from "./locales/ja/callHistory.json";
import callHistoryEn from "./locales/en/callHistory.json";
import castShiftJa from "./locales/ja/castShift.json";
import castShiftEn from "./locales/en/castShift.json";
import aiSupportJa from "./locales/ja/aiSupport.json";
import aiSupportEn from "./locales/en/aiSupport.json";
import companyJa from "./locales/ja/company.json";
import companyEn from "./locales/en/company.json";
import requestGuestJa from "./locales/ja/requestGuest.json";
import requestGuestEn from "./locales/en/requestGuest.json";
import orderJa from "./locales/ja/order.json";
import orderEn from "./locales/en/order.json";
import castScheduleJa from "./locales/ja/castSchedule.json";
import castScheduleEn from "./locales/en/castSchedule.json";
import masterJa from "./locales/ja/master.json";
import masterEn from "./locales/en/master.json";
import notificationJa from "./locales/ja/notification.json";
import notificationEn from "./locales/en/notification.json";
import layoutJa from "./locales/ja/layout.json";
import layoutEn from "./locales/en/layout.json";
import accountingJa from "./locales/ja/accounting.json";
import accountingEn from "./locales/en/accounting.json";
import paymentJa from "./locales/ja/payment.json";
import paymentEn from "./locales/en/payment.json";
import bookEmailJa from "./locales/ja/bookEmail.json";
import bookEmailEn from "./locales/en/bookEmail.json";
import orderListJa from "./locales/ja/orderList.json";
import orderListEn from "./locales/en/orderList.json";
import guestAnalyticsJa from "./locales/ja/guestAnalytics.json";
import guestAnalyticsEn from "./locales/en/guestAnalytics.json";
import castRankingJa from "./locales/ja/castRanking.json";
import castRankingEn from "./locales/en/castRanking.json";
import messageTemplateJa from "./locales/ja/messageTemplate.json";
import messageTemplateEn from "./locales/en/messageTemplate.json";
import signupJa from "./locales/ja/signup.json";
import signupEn from "./locales/en/signup.json";
import marketingMailJa from "./locales/ja/marketingMail.json";
import marketingMailEn from "./locales/en/marketingMail.json";
import commonJa from "./locales/ja/common.json";
import commonEn from "./locales/en/common.json";
// tutorial の訳は features/tutorial/locales/ に在ったが、ここへ登録されていなかった。
// そのため t() が常にフォールバック（第2引数の日本語）を返し、英語 UI でも
// 初回セットアップのダイアログだけ日本語で出ていた（2026-08-25 QA で実測）。
import tutorialJa from "../features/tutorial/locales/ja.json";
import tutorialEn from "../features/tutorial/locales/en.json";

const resources = {
  ja: {
    login: loginJa,
    dashboard: dashboardJa,
    setting: settingJa,
    board: boardJa,
    task: taskJa,
    analytics: analyticsJa,
    settlement: settlementJa,
    driverShift: driverShiftJa,
    guest: guestJa,
    callHistory: callHistoryJa,
    castShift: castShiftJa,
    aiSupport: aiSupportJa,
    company: companyJa,
    requestGuest: requestGuestJa,
    order: orderJa,
    castSchedule: castScheduleJa,
    master: masterJa,
    notification: notificationJa,
    layout: layoutJa,
    accounting: accountingJa,
    payment: paymentJa,
    bookEmail: bookEmailJa,
    orderList: orderListJa,
    guestAnalytics: guestAnalyticsJa,
    castRanking: castRankingJa,
    messageTemplate: messageTemplateJa,
    signup: signupJa,
    marketingMail: marketingMailJa,
    common: commonJa,
    tutorial: tutorialJa,
  },
  en: {
    login: loginEn,
    dashboard: dashboardEn,
    setting: settingEn,
    board: boardEn,
    task: taskEn,
    analytics: analyticsEn,
    settlement: settlementEn,
    driverShift: driverShiftEn,
    guest: guestEn,
    callHistory: callHistoryEn,
    castShift: castShiftEn,
    aiSupport: aiSupportEn,
    company: companyEn,
    requestGuest: requestGuestEn,
    order: orderEn,
    castSchedule: castScheduleEn,
    master: masterEn,
    notification: notificationEn,
    layout: layoutEn,
    accounting: accountingEn,
    payment: paymentEn,
    bookEmail: bookEmailEn,
    orderList: orderListEn,
    guestAnalytics: guestAnalyticsEn,
    castRanking: castRankingEn,
    messageTemplate: messageTemplateEn,
    signup: signupEn,
    marketingMail: marketingMailEn,
    common: commonEn,
    tutorial: tutorialEn,
  },
};

/**
 * ★言語の 決め方★
 *
 * 一 URL の ?lang=  二 localStorage の "lang"  三 既定の ja
 *
 * ★一が 無かった★（2026-08-13 実測）。
 * localStorage しか 見ておらず、初めて来た人は 必ず ja に 落ちていた。
 * tasteck.tech/en/signup は ★?lang=en 付きで★ 此処へ 送っているのに、
 * 独の相手が 開いても 全項目 日本語のままで、
 * ★会社名カナが 必須★ なので 物理的に 埋められない状態だった。
 *
 * ★国内は 1 文字も 変わらぬ★ ── 国内の 導線に ?lang= は 付かないので
 * 二・三に 落ち、これまでと 同じ ja になる。
 */
const readLangFromQuery = (): string | null => {
  if (typeof window === "undefined" || !window.location) return null;
  const v = new URLSearchParams(window.location.search).get("lang");
  return v === "en" || v === "ja" ? v : null;
};

const queryLang = readLangFromQuery();
const storedLang =
  typeof window !== "undefined" && window.localStorage
    ? window.localStorage.getItem("lang")
    : null;

// ★URL で 来た言語は 覚えておく★
// 覚えないと、次の頁へ 進んだ時点（?lang= が 付かない）で 日本語へ 戻ってしまう。
if (queryLang && typeof window !== "undefined" && window.localStorage) {
  window.localStorage.setItem("lang", queryLang);
}

const savedLang = queryLang || storedLang;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang === "en" || savedLang === "ja" ? savedLang : "ja",
    fallbackLng: "ja",
    interpolation: {
      escapeValue: false,
    },
    ns: ["login", "dashboard", "setting", "board", "task", "analytics", "settlement", "driverShift", "guest", "callHistory", "castShift", "aiSupport", "company", "requestGuest", "order", "castSchedule", "master", "notification", "layout", "accounting", "payment", "bookEmail", "orderList", "guestAnalytics", "castRanking", "messageTemplate", "signup", "marketingMail", "common", "tutorial"],
    defaultNS: "login",
  });

export default i18n;
